import { novaClient } from "@/lib/trpc";

// Staffer-authored notes on a user, newest first.
export const useGetUserNotes = ({ userId }: { userId: number }) => {
  return novaClient.internal.user.note.list.useQuery({ userId });
};
